module.exports = __webpack_public_path__ + "static/img/Logo-B_pequena.6c360dd8.png";